/**
 * 集成模块统一导出
 */

export {
  integrateWithAutoTrigger,
  initTrackerV2,
} from "./autoTriggerIntegration";
